export const FEATURED = "filter/featured";
